import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SavePropertyArea = async (propertyArea,navigate, jobsiteID) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
        let Payload =
            {
              "propertyAreaID": propertyArea.propertyAreaID,
              "jobsiteID": jobsiteID,              
              "propertyAreaType": propertyArea.propertyAreaType,
              "propertyAreaName": propertyArea.propertyAreaName,
              "description":  propertyArea.description,
              "measurement":Array.isArray(propertyArea.measurement)? propertyArea.measurement : [propertyArea.measurement] ,         
            }        
          
      const response = await fetch(`${dev_baseUrl}/PropertyArea/savePropertyArea`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });

      const data = await response.json();
      
    if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
    } else if(response.ok && !data.isError ){      
      return data;
    } 
    else {
      console.error('Server Error:',data.message);
      return data;
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
